"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import { Tooltip } from '../Tooltip/index.mjs';
import { cn } from '../../helpers/cn.mjs';
import useEventStopPropagation from '../../helpers/hooks/useEventStopPropagation.mjs';
import { useState } from 'react';
import { SvgIcon } from '../SvgIcon/index.mjs';

const copyButtonStyles = cn(
  "field-copy-button",
  "absolute right-1 top-1/2 -translate-y-1/2 z-[1]",
  "flex items-center justify-center",
  "w-6 h-6 rounded-md cursor-pointer",
  "text-fg-subtle bg-bg-default border border-solid border-border-subtle",
  "opacity-0 transition-opacity duration-150",
  "hover:bg-bg-subtle",
  "[&_svg]:w-3.5 [&_svg]:h-3.5"
);
function FieldCopy({ value }) {
  const [copied, setCopied] = useState(false);
  const handleClick = useEventStopPropagation(async () => {
    if (value != null) {
      try {
        await navigator.clipboard.writeText(String(value));
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      } catch (err) {
        console.warn("Failed to copy to clipboard:", err);
      }
    }
  });
  return /* @__PURE__ */ jsx(Tooltip, { tooltip: copied ? "Copied!" : "Copy", usePortal: true, children: /* @__PURE__ */ jsx("button", { className: copyButtonStyles, onClick: handleClick, "aria-label": "Copy", children: /* @__PURE__ */ jsx(SvgIcon, { type: copied ? SvgIconType.Check : SvgIconType.Copy }) }) });
}

export { FieldCopy };
